import React, { useState } from 'react'

import { Dialog3 as Dialog } from '@st-operations/uikit/src/v1/index.js'
import Header from '_components/header/index.jsx'
import NewEntityDialog from '_components/new-entity-dialog/index.jsx'
import ListView from '_components/list-view/index.jsx'

const APADataSources = () => {
  const [modalOpen, setModalOpen] = useState(false)

  const handleModalOpenClose = () => {
    setModalOpen(!modalOpen)
  }

  return (
    <div id="apa-data-sources-page">
      <Header
        title="APA Data Sources"
        actions={[
          {
            children: 'Create New data source',
            onClick: handleModalOpenClose,
          },
        ]}
      />

      <ListView
        columns={[
          {
            name: 'Name',
            key: 'name',
            link: `/data-sources-apa/:_id`,
            sortable: true,
          },
          {
            name: '1x30 sampling rate',
            key: '1x30',
          },
          {
            name: '30x30 sampling rate',
            key: '1x30',
          },
          {
            name: '70x30 sampling rate',
            key: '7x30',
          },
        ]}
        entities="data-sources-apa"
        fields={['name', 'index', '1x30', '1x30', '7x30']}
        filters={[]}
        searchable={true}
        sort_dir={1}
        sort_key={'name'}
      />
      <Dialog open={modalOpen} close={handleModalOpenClose}>
        <NewEntityDialog
          close={handleModalOpenClose}
          entities="data-sources-apa"
          title="Enter a name for the data source"
        />
      </Dialog>
    </div>
  )
}

export default APADataSources
